export default __webpack_public_path__ + "static/media/alex.d6f4bfb0.jpg";